import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildNoticeEntity } from "@youm-front/notice/util/factory";
import { NOTICE_FEATURE_KEY, NoticeState, noticeAdapter } from "../reducers";

const noticeState = createFeatureSelector<NoticeState>(NOTICE_FEATURE_KEY);

const { selectAll: selectAllNotices } = noticeAdapter.getSelectors();

export const notices = createSelector(noticeState, (state: NoticeState) => {
  return selectAllNotices(state).map((_) => buildNoticeEntity(_));
});
